import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/mangaData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h4 className="font-heading text-xl text-background-50 mb-4">{siteInfo.name}</h4>
              <p className="text-sm text-background-400 leading-relaxed">
                {siteInfo.tagline}，精选高分bl漫画作品推荐，涵盖甜宠、虐心、古风、现代等多种题材。
              </p>
              <div className="flex items-center gap-3 mt-4">
                <a
                  href={siteInfo.socialLinks.weibo}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer"
                  aria-label="微博"
                >
                  <i className="ri-weibo-line text-background-200"></i>
                </a>
                <a
                  href={siteInfo.socialLinks.bilibili}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer"
                  aria-label="哔哩哔哩"
                >
                  <i className="ri-bilibili-line text-background-200"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-lg text-background-50 mb-4">分类导航</h4>
              <div className="flex flex-col gap-2">
                {categories.filter(c => c.slug !== 'all').map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading text-lg text-background-50 mb-4">热门推荐</h4>
              <div className="flex flex-col gap-2">
                <Link to="/article/3" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">长安幻夜</Link>
                <Link to="/article/10" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">浮生若梦</Link>
                <Link to="/article/6" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">花间集</Link>
                <Link to="/article/1" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">春日限定</Link>
                <Link to="/article/8" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">暗夜追踪</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-lg text-background-50 mb-4">关于我们</h4>
              <div className="flex flex-col gap-2">
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">品牌介绍</Link>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">联系方式</Link>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">网站首页</Link>
              </div>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {currentYear} {siteInfo.name} 版权所有 | 本站内容仅供阅读参考
            </p>
            <p className="text-xs text-background-500">
              BL漫画精选 - 最新最全bl漫画在线阅读平台
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}